// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as PnMVm$PorterinFeature from "../../../../containers/pnm/view/view-models/PnMVm.mjs";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as ClickableIconCmp$PorterinFeature from "../../../../containers/category-page/view/components/ClickableIconCmp.mjs";
import * as SpotEstimateInputModuleScss from "../styles/SpotEstimateInput.module.scss";

var styles = SpotEstimateInputModuleScss;

function SpotEstimateInputCmp(Props) {
  var label = Props.label;
  var is_required = Props.is_required;
  var is_filled = Props.is_filled;
  var children = Props.children;
  var error = Props.error;
  var input_image = Props.input_image;
  var clear_input = Props.clear_input;
  var show_clear_btnOpt = Props.show_clear_btn;
  var show_clear_btn = show_clear_btnOpt !== undefined ? show_clear_btnOpt : false;
  var match = React.useState(function () {
        return false;
      });
  var setFocused = match[1];
  return React.createElement("div", {
              className: styles.container,
              onFocus: (function (param) {
                  Curry._1(setFocused, (function (param) {
                          return true;
                        }));
                }),
              onBlur: (function (param) {
                  Curry._1(setFocused, (function (param) {
                          return false;
                        }));
                })
            }, React.createElement("div", {
                  className: Belt_Option.isSome(error) ? "" + styles["input-container"] + " " + styles["input-container-error"] + "" : (
                      match[0] ? "" + styles["input-container-focus"] + " " + styles["input-container"] + "" : styles["input-container"]
                    )
                }, input_image !== undefined ? React.createElement("div", {
                        className: styles["icon-wrapper"]
                      }, React.createElement(NextImage$PorterinFeature.make, {
                            src: input_image.path,
                            height: 18.0,
                            width: 18.0,
                            quality: 70.0,
                            alt: input_image.alt_text
                          })) : null, React.createElement("div", {
                      className: styles["field-wrapper"]
                    }, React.createElement("label", {
                          className: "" + (
                            is_required ? styles["label-required"] : styles.label
                          ) + " \n            " + (
                            Belt_Option.isSome(error) ? styles.error : ""
                          ) + " \n            " + (
                            is_filled ? "" : styles.filled
                          ) + "\n            ",
                          htmlFor: label
                        }, label), children, !is_filled && show_clear_btn ? React.createElement(ClickableIconCmp$PorterinFeature.make, {
                            class_name: styles["clear-icon"],
                            on_icon_click: clear_input,
                            icon: PnMVm$PorterinFeature.clearInputIcon
                          }) : null)), error !== undefined ? React.createElement("div", {
                    className: styles["error-container"]
                  }, error) : null);
}

var make = SpotEstimateInputCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
